//Notification Bar from Moo shared library is not suitable as it requires:
//  1 .copying 2 service for translation dependecy (that its not needed in any other places of the app )
//  2. one service for alert (that its not needed in any other places o the app)
//  3. overriding CSS styles as it has internal paddings and margins that are not suitable for needed result
//  4. has mandatory Icon that i should not show 
//  5. enforces a title and text message  where i only need a text message (can be ovverriden by spaces but generates wierd code  )
//  6. has internal Observables to show error. and i need the host component to be in charge of what to show and when
//  7. did not see how i can hide this notification bar externally   
import { Component } from "@angular/core";
import { isDefined } from "../helpers";

export enum AlertType {
  success = "success",
  info = "info",
  warning = "warning",
  danger = "danger",
  primary = "primary",
  secondary = "secondary",
  light = "light",
  dark = "dark"
}

export interface NotificationBarConfig {
  text: string;
  icon?: string;
  showIcon?: boolean;
  dismissible?: boolean;
}
@Component({
  selector: "au-notification-bar",
  templateUrl: "./notification-bar.component.html",
  styleUrls: ["./notification-bar.component.scss"]
})
export class NotificationBarComponent {

  type = "secondary";
  icon = "info";
  message = "message";
  isVisible = false;
  showIcon: boolean = true;
  dismissible = false; 

  getFeatherIcon(): string {
    return "feather " + this.icon;
  }

  hide() {
    this.isVisible = false;
  }

  showInfoMessage(config: NotificationBarConfig) {
    this.type = AlertType.primary.toString();
    if (!isDefined(config.icon)) {
      config.icon = "icon-info";
    }
    this.showMessage(config);
  }

  showWarningMessage(config: NotificationBarConfig) {
    this.type = AlertType.warning.toString();
    if (!isDefined(config.icon)) {
      config.icon = "icon-alert-triangle";
    }
    this.showMessage(config);
  }

  showErrorMessage(config: NotificationBarConfig) {
    this.type = AlertType.danger.toString();
    if (!isDefined(config.icon)) {
      config.icon = "icon-alert-triangle";
    }
    this.showMessage(config);
  }

  showSuccessMessage(config: NotificationBarConfig) {
    this.type = AlertType.success.toString();
    if (!isDefined(config.icon)) {
      config.icon = "icon-check-circle";
    }
    this.showMessage(config);
  }

  private showMessage(config: NotificationBarConfig) {
    this.isVisible = false;
    this.message = config.text;
    this.icon = config.icon ?? "";
    this.showIcon = config.showIcon ?? true;
    this.isVisible = true;
    this.dismissible = config.dismissible ?? false;
  }
}
